var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-collapse",
    {
      staticClass: "evaluation-card",
      attrs: {
        animation: "slide",
        open: _vm.isOpen,
        "data-cy": "associated-insurance-data",
      },
      scopedSlots: _vm._u([
        {
          key: "trigger",
          fn: function ({ open }) {
            return [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { role: "button", "aria-expanded": open.toString() },
                },
                [
                  _c("p", { staticClass: "card-header-title" }, [
                    _vm._v(" Seguros asociados "),
                  ]),
                  _c(
                    "a",
                    { staticClass: "card-header-icon" },
                    [
                      _c("b-icon", {
                        attrs: { icon: open ? "minus" : "plus" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "card-block" },
        [
          _c(
            "b-field",
            {
              staticClass: "has-addons",
              attrs: { label: "Cuota seguro de crédito", horizontal: "" },
            },
            [
              _c(
                "div",
                { staticClass: "field has-addons" },
                [
                  _c("p", { staticClass: "control" }, [
                    _c("a", { staticClass: "button is-static" }, [
                      _vm._v("UF"),
                    ]),
                  ]),
                  _c("b-input", {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      type: "number",
                      placeholder: "Ingresa valor en UF",
                      expanded: "",
                    },
                    model: {
                      value: _vm.simulation.offerResponse.creditInsuranceFee,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerResponse,
                          "creditInsuranceFee",
                          $$v
                        )
                      },
                      expression: "simulation.offerResponse.creditInsuranceFee",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "b-field",
            {
              staticClass: "has-addons",
              attrs: { label: "Cuota seg. desgravamen", horizontal: "" },
            },
            [
              _c(
                "div",
                { staticClass: "field has-addons" },
                [
                  _c("p", { staticClass: "control" }, [
                    _c("a", { staticClass: "button is-static" }, [
                      _vm._v("UF"),
                    ]),
                  ]),
                  _c("b-input", {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      type: "number",
                      placeholder: "Ingresa valor en UF",
                      expanded: "",
                    },
                    model: {
                      value: _vm.simulation.offerResponse.lifeInsuranceFee,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerResponse,
                          "lifeInsuranceFee",
                          $$v
                        )
                      },
                      expression: "simulation.offerResponse.lifeInsuranceFee",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "b-field",
            {
              staticClass: "has-addons",
              attrs: { label: "Cuota seg. de propiedad", horizontal: "" },
            },
            [
              _c(
                "div",
                { staticClass: "field has-addons" },
                [
                  _c("p", { staticClass: "control" }, [
                    _c("a", { staticClass: "button is-static" }, [
                      _vm._v("UF"),
                    ]),
                  ]),
                  _c("b-input", {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      type: "number",
                      placeholder: "Ingresa valor en UF",
                      expanded: "",
                    },
                    model: {
                      value: _vm.simulation.offerResponse.propertyInsuranceFee,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerResponse,
                          "propertyInsuranceFee",
                          $$v
                        )
                      },
                      expression:
                        "simulation.offerResponse.propertyInsuranceFee",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "b-field",
            {
              staticClass: "has-addons",
              attrs: { label: "Cuota seg. cesantía", horizontal: "" },
            },
            [
              _c(
                "div",
                { staticClass: "field has-addons" },
                [
                  _c("p", { staticClass: "control" }, [
                    _c("a", { staticClass: "button is-static" }, [
                      _vm._v("UF"),
                    ]),
                  ]),
                  _c("b-input", {
                    attrs: {
                      disabled: _vm.readOnly,
                      size: "is-small",
                      type: "number",
                      placeholder: "Ingresa valor en UF",
                      expanded: "",
                    },
                    model: {
                      value:
                        _vm.simulation.offerResponse.unemploymentInsuranceFee,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerResponse,
                          "unemploymentInsuranceFee",
                          $$v
                        )
                      },
                      expression:
                        "simulation.offerResponse.unemploymentInsuranceFee",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }